/**
 * Dirifies a string, for example, from 'some thing' to 'some-thing'.
 * Translate:
 *  - Dashes '-' to under dashes '_' (needed for some languages like french)
 *  - Spaces ' ' to dashes '-'.
 *
 * @param {string} term
 */
export const dirify = term => (term ? term.replace(/-/g, '_').replace(/\s/g, '-') : '');

/**
 * Dedirifies a string, for example, from 'some-thing' to 'some thing'.
 * Translate:
 *  - Dashes '-' to spaces ' '.
 *  - Under dashes '_' to dashes '-' (needed for some languages like french)
 *
 * @param {string} term
 */
export const dedirify = term => (term ? term.replace(/-/g, ' ').replace(/_/g, '-') : '');



// WEBPACK FOOTER //
// ./app/utils/dirify.js